export enum TRANSACTION_MODALITY {
  IN = 0,
  OUT = 1,
}
export enum TRANSACTION_TYPE {
  INTER_LEDGER = "INTER_LEDGER",
  CARD_AUTHORIZATION = "CARD_AUTHORIZATION",
  CARD_CLEARING = "CARD_CLEARING",
  SEPA_DIRECT_DEBIT = "SEPA_DIRECT_DEBIT",
  ACQUIRING = "ACQUIRING",
  FX = "FX",
  SEPA_CREDIT_TRANSFER = "SEPA_CREDIT_TRANSFER",
  UK_CREDIT_TRANSFER = "UK_CREDIT_TRANSFER",
  UNKNOWN = "UNKNOWN",
}

export enum transactionDirection {
  DEBIT = "DEBIT",
  CREDIT = "CREDIT",
  ALL = "ALL",
}

export enum TRANSACTION_STATUS {
  APPROVED = "APPROVED",
  DECLINED = "DECLINED",
  RELEASED = "RELEASED",
  REVERSED = "REVERSED",
  PENDING = "PENDING",
  PENDING_REVIEW = "PENDING_REVIEW",
  UNKNOWN = "UNKNOWN",
  ABORTED = "ABORTED",
}

export enum PAYMENT_TYPES {
  MONEY_TRANSFER = "MONEY_TRANSFER",
  TECH_MVC_CREATION = "TECH_MVC_CREATION",
  TECH_TRANSACTION = "TECH_TRANSACTION",
  TECH_VIRTUAL_TRANSFER = "TECH_VIRTUAL_TRANSFER",
  ACCOUNT_LOAD = "ACCOUNT_LOAD",
  PAYMENT = "PAYMENT",
  ACCOUNT_FUNDING = "ACCOUNT_FUNDING",
  ACCOUNT_TRANSFER = "ACCOUNT_TRANSFER",
  ACCOUNT_VERIFICATION = "ACCOUNT_VERIFICATION",
  ADJUSTMENT_CREDIT = "ADJUSTMENT_CREDIT",
  ADJUSTMENT_DEBIT = "ADJUSTMENT_DEBIT",
  CASH_ADVANCE = "CASH_ADVANCE",
  CARD_LOAD = "CARD_LOAD",
  CARD_UNLOAD = "CARD_UNLOAD",
  CHECK_DEPOSIT = "CHECK_DEPOSIT",
  DEPOSIT = "DEPOSIT",
  FEE_COLLECTION = "FEE_COLLECTION",
  ORIGINAL_CREDIT = "ORIGINAL_CREDIT",
  PAYMENT_TRANSACTION = "PAYMENT_TRANSACTION",
  PURCHASE = "PURCHASE",
  PURCHASE_RETURN_OR_REFUND = "PURCHASE_RETURN_OR_REFUND",
  PURCHASE_WITH_CASHBACK = "PURCHASE_WITH_CASHBACK",
  QUASI_CASH = "QUASI_CASH",
  UNIQUE_MCC_TRANSACTION = "UNIQUE_MCC_TRANSACTION",
  WITHDRAWAL = "WITHDRAWAL",
  TECH_CARD_SETTLEMENT = "TECH_CARD_SETTLEMENT",
  SCT_RECEIVE = "SCT_RECEIVE",
  SCT_INST_RECEIVE = "SCT_INST_RECEIVE",
  SCT_SEND = "SCT_SEND",
  SCT_INST_SEND = "SCT_INST_SEND",
  SDD_SEND = "SDD_SEND",
  SDD_RECEIVE = "SDD_RECEIVE",
  BACS_RECEIVE = "BACS_RECEIVE",
  FASTER_PAYMENT_RECEIVE = "FASTER_PAYMENT_RECEIVE",
  BACS_SEND = "BACS_SEND",
  FASTER_PAYMENT_SEND = "FASTER_PAYMENT_SEND",
  GLOBAL_SWIFT = "GLOBAL_SWIFT",
  UNKNOWN = "UNKNOWN",
}

export enum PAIEMENT_FILTER {
  INTER_LEDGER = "INTER_LEDGER",
  SCT = "SCT",
  SCT_FAST = "SCT_FAST",
  SDD = "SDD",
  WITHDRAWAL = "WITHDRAWAL",
  PAIEMENT = "PAIEMENT",
  ALL = "ALL",
  CARD = "CARD",
}

export enum STATUS_FILTER {
  VALIDATED = "VALIDATED",
  PENDING = "PENDING",
  INCOMING = "INCOMING",
  DECLINED = "DECLINED",
  REVERSED = "REVERSED",
  REFUND = "REFUND",
  ALL = "ALL",
}

export enum TRX_TYPE_ENUM {
  FEE = 2,
  PAYMENT = 3,
  PAYMENT_CANCELLATION = 4,
  PAYMENT_RETURN = 5,
  FEE_CANCELLATION = 6,
  CCY_EXCHANGE = 7,
  ADJUSTMENT = 8,
  PAYMENT_TECHNICAL_REVERSAL = 9,
  PAYMENT_REVERSAL = 10,
  CARD_AUTH = 11,
  CARD_ADVICE = 12,
  CARD_REVERSAL = 13,
  FX_POSITION_CLOSING = 14,
  CARD_CLEARING = 15,
}

export enum TRX_METHOD_ENUM {
  SCT_SEPA = 1,
  INTERNAL = 2,
  SDD = 5,
  DDI_INTERNAL = 6,
  INST_SEPA = 8,
  CARD = 9,
}

export enum TRX_STATUS_ENUM {
  CREATED = 1,
  SIGNED = 2,
  REVIEW = 3,
  READY_TO_CLEAR = 4,
  SENT_TO_PACK = 5,
  PACKED = 6,
  SENT_TO_CLEAR = 7,
  COMPLETED = 8,
  SOME_PROBLEMS = 9,
  CANCELLED = 10,
  REJECTED = 11,
  INVALID = 12,
  ACCEPTED = 13,
  TO_SIGN = 14,
  RESERVED = 15,
  TO_RESERVE = 16,
  RECEIVED = 17,
  DROPPED = 18,
  ON_HOLD = 19,
  READY_FOR_SCREENING = 20,
  AML_APPROVED = 21,
  AML_REJECTED = 22,
  MANUAL_ACTION = 23,
  CREDIT_TECH_BALANCE = 24,
  TO_RESEND = 25,
  MANUAL_REJECTED = 26,
  TO_CANCEL = 27,
  BLACKLIST_SCANNING = 28,
  AML_SCANNING = 29,
}

export const FINAL_OK = new Set<TRX_STATUS_ENUM>([
  TRX_STATUS_ENUM.COMPLETED,
  TRX_STATUS_ENUM.ACCEPTED,
  TRX_STATUS_ENUM.AML_APPROVED,
  TRX_STATUS_ENUM.CREDIT_TECH_BALANCE,
]);

export const CANCELLED_LIKE = new Set<TRX_STATUS_ENUM>([
  TRX_STATUS_ENUM.CANCELLED,
  TRX_STATUS_ENUM.DROPPED,
  TRX_STATUS_ENUM.TO_CANCEL,
]);

export const REJECTED_LIKE = new Set<TRX_STATUS_ENUM>([
  TRX_STATUS_ENUM.REJECTED,
  TRX_STATUS_ENUM.MANUAL_REJECTED,
  TRX_STATUS_ENUM.AML_REJECTED,
  TRX_STATUS_ENUM.INVALID,
]);

export const IN_PROGRESS = new Set<TRX_STATUS_ENUM>([
  TRX_STATUS_ENUM.CREATED,
  TRX_STATUS_ENUM.SIGNED,
  TRX_STATUS_ENUM.REVIEW,
  TRX_STATUS_ENUM.READY_TO_CLEAR,
  TRX_STATUS_ENUM.SENT_TO_PACK,
  TRX_STATUS_ENUM.PACKED,
  TRX_STATUS_ENUM.SENT_TO_CLEAR,
  TRX_STATUS_ENUM.TO_SIGN,
  TRX_STATUS_ENUM.RESERVED,
  TRX_STATUS_ENUM.TO_RESERVE,
  TRX_STATUS_ENUM.RECEIVED,
  TRX_STATUS_ENUM.ON_HOLD,
  TRX_STATUS_ENUM.READY_FOR_SCREENING,
  TRX_STATUS_ENUM.AML_SCANNING,
  TRX_STATUS_ENUM.BLACKLIST_SCANNING,
  TRX_STATUS_ENUM.MANUAL_ACTION,
  TRX_STATUS_ENUM.TO_RESEND,
]);

// Types qui représentent un remboursement / reversal
export const REFUND_TYPES = new Set<TRX_TYPE_ENUM>([
  TRX_TYPE_ENUM.PAYMENT_RETURN,
  TRX_TYPE_ENUM.PAYMENT_REVERSAL,
  TRX_TYPE_ENUM.CARD_REVERSAL,
  TRX_TYPE_ENUM.PAYMENT_CANCELLATION,
]);
